import { useEffect, useState } from 'react'

export default function useIsReactClient() {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return isClient
}